import { render } from "./JellyButton.vue?vue&type=template&id=292cc434&scoped=true&ts=true"
import script from "./JellyButton.vue?vue&type=script&lang=ts"
export * from "./JellyButton.vue?vue&type=script&lang=ts"

import "./JellyButton.vue?vue&type=style&index=0&id=292cc434&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292cc434"]])

export default __exports__